import React from "react";
import { useSelector } from "react-redux";

import { Theme } from "consts";
import { Navigator } from "router";
import { getSurveyQuestionnaire } from "screens/question/selectors";

import ThemeA from "./themeA";
import ThemeB from "./themeB";

const Question = () => {
  const questionnaire = useSelector(getSurveyQuestionnaire);
  if (!questionnaire) {
    if (__DEV__) {
      // auto redirect for quick development
      setTimeout(() => Navigator.jumpTo("loading"), 100);
    }
    return null;
  }

  const QuestionTheme = themes[questionnaire.theme];
  return <QuestionTheme questionnaire={questionnaire} />;
};

export default Question;

const themes = {
  [Theme.RETRO]: ThemeA,
  [Theme.MODERN]: ThemeB,
};
